import BaseTableNew from 'components/atoms/base-table/new';
import useUser from 'utils/useUser';

import { useCols } from './cols';
import s from './styles.module.scss';

import type { IClinicCareManagerLite } from 'infrastructure/interfaces';

interface IProps {
  items: IClinicCareManagerLite[];
}

const CareManagersEditTable = ({ items = [] }: IProps) => {
  const user = useUser();
  const disableRefs = !user.isAgencyDoctor;
  const { cols } = useCols({ disableRefs });

  return (
    <BaseTableNew
      bordered
      rowClassName={s['table-row']}
      items={items}
      pagination={{
        current: 1,
        pageSize: 9999,
        total: 9999,
      }}
      columns={cols}
    />
  );
};
export default CareManagersEditTable;
